"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eight/sections/videoSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import Lightbox, { type LightboxSlide } from "../../Components/Lightbox";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode } from "react";

export type HomeEightVideoSectionGeneratedProps = {
    lightboxSlides?: LightboxSlide[];
    lightboxOpen?: boolean;
    lightboxIndex?: number;
    onLightboxClose?: () => void;
    onLightboxView?: (index: number) => void;
    onOpenLightbox?: (index: number) => void;
    /** Default: "video-bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/video-8-bg.jpg" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "" */
    sectionLink0LinkDataFancybox?: string;
    /** Default: "#" */
    sectionLink0LinkHref?: string;
    sectionLink0LinkVisible?: boolean;
    sectionLink0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Play Video Play Video " */
    sectionLink0Button0ButtonDataText?: string;
    sectionLink0Button0ButtonVisible?: boolean;
    sectionLink0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionLink0Button0ButtonProps?: Partial<ComponentProps<"button">>;
};

const HomeEightVideoSectionGenerated: FC<HomeEightVideoSectionGeneratedProps> = ({
    lightboxSlides = [],
    lightboxOpen,
    lightboxIndex,
    onLightboxClose,
    onLightboxView,
    onOpenLightbox,
    sectionImageWithBasePath0ImageAlt = "video-bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/video-8-bg.jpg",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionLink0Button0ButtonDataText = "Play Video Play Video ",
    sectionLink0Button0ButtonVisible,
    sectionLink0Button0ButtonRenderer,
    sectionLink0Button0ButtonProps,
    sectionLink0LinkDataFancybox = "",
    sectionLink0LinkHref = "#",
    sectionLink0LinkVisible,
    sectionLink0LinkRenderer,
    sectionLink0LinkProps,
}) => {
    return (
        <>
            <section className="video-section-eight">
                {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                    <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionImageWithBasePath0ImageProps ?? {})} />
                ))}
                {renderNode(sectionLink0LinkVisible, sectionLink0LinkRenderer, (
                    <SmartLink href={sectionLink0LinkHref} data-fancybox={sectionLink0LinkDataFancybox} {...(sectionLink0LinkProps ?? {})}>
                        {renderNode(sectionLink0Button0ButtonVisible, sectionLink0Button0ButtonRenderer, (
                            <button className="animate-button" data-text={sectionLink0Button0ButtonDataText} {...(sectionLink0Button0ButtonProps ?? {})}>
                                <p className="button-text"></p>
                                <span className="button-circle">
                                    <i className="isax isax-pause"></i>
                                </span>
                            </button>
                        ))}
                    </SmartLink>
                ))}
            </section>
            <Lightbox images={lightboxSlides} currentIndex={lightboxIndex ?? 0} isOpen={lightboxOpen} onClose={() => onLightboxClose?.()} onNavigate={(index) => onLightboxView?.(index)} />
        </>
    );
};

export default HomeEightVideoSectionGenerated;
